<template>
    <div>
        <md-dialog :md-active.sync="value">
            <div>
                <form novalidate class="md-layout">
                    <md-card style="min-width: 400px;">
                        <md-card-header>
                            <b-row>
                                <b-col><div class="md-title">Entry overlapping</div></b-col>
                                <b-col style="text-align:right">
                                    <md-button class="md-icon-button md-dense" @click="onClosed"><md-icon>highlight_off</md-icon></md-button>
                                </b-col>
                            </b-row>
                        </md-card-header>
                        <md-card-content>
                            <b-row>
                                <b-col>
                                    <p>This entry will overlap with existing entries. Are you sure?</p>
                                </b-col>
                            </b-row>
                        </md-card-content>
                        <md-card-actions>
                            <md-button class="md-button" @click="onDeclined">Decline</md-button>
                            <md-button class="md-button btn-primary" @click="onConfirmed">Confirm</md-button>
                        </md-card-actions>
                    </md-card>
                </form>
            </div>
        </md-dialog>
    </div>
</template>

<script>
    export default {
        name: "EventOverlappingConfirmationDialog",
        props: {
            value: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {};
        },
        methods: {
            onClosed() {
                this.$emit('closed');
                this.$emit('input', false);
            },
            onDeclined() {
                this.$emit('declined');
                this.onClosed();
            },
            onConfirmed() {
                this.$emit('confirmed');
                this.onClosed();
            },
        },
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/property-calendar/dialogs/EventOverlappingConfirmationDialog.vue